import { useContext, useState, useEffect } from "react";

import { isEmpty } from "lodash";

import { FileProps } from "@/components/FilesUpload/types";
import { Typography } from "@/components/Typography";
import { Form } from "@/components/Form";

import { QREditorContext } from "@/contexts/QREditorContext";
import { QREditorContextProps, QRProps } from "@/contexts/QREditorContext/types";

import { applyQRFormDefaultValues, onBindClick } from "@/utils/formHelper";
import { isFileAblob, onBindThemePicker } from "@/utils/qrEditorHelper";
import { pdfValidation } from "@/utils/validators/qr-pdf";

import { QRPdfProps } from "./types";

import { NAMESPACES } from "@/internals/constants/namespaces";
import { useTranslation } from "react-i18next";
import "./styles.scss";

export const QRPdf = ({ data }: QRPdfProps) => {
  const { t } = useTranslation(NAMESPACES.VALIDATIONS);
  const { qrData, setQrData } = useContext<QREditorContextProps<"pdf">>(QREditorContext);

  const [qrPdfData, setQrPdfData] = useState<QRProps<"pdf">>(qrData);
  const [renderForm, setRenderForm] = useState(false);

  const omittedValues =
    isEmpty(qrData.data.pdfFileUrl) || isFileAblob(qrData.data.pdfFileUrl)
      ? ["data.pdfFileUrl"]
      : [];

  const dataPdfWithDefaultValues = applyQRFormDefaultValues(data, qrData.data);

  onBindThemePicker(dataPdfWithDefaultValues, "themeColor", omittedValues);

  onBindClick(dataPdfWithDefaultValues, "pdfUrls", (pdfUrls: FileProps[]) => {
    setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          pdfFileUrl: pdfUrls[0]?.url as string,
          pdfFileName: pdfUrls[0]?.name,
          size: pdfUrls[0]?.size,
        },
      },
      omittedValues
    );
  });

  const onUpdateState = ({ field, value }) => {
    if (field === "file" || field == "") return;
    setQrData(
      {
        ...qrData,
        data: {
          ...qrData.data,
          [field]: value,
        },
      },
      omittedValues
    );
  };

  useEffect(() => {
    setQrPdfData(qrData);
  }, [qrData]);

  useEffect(() => {
    setQrData({ ...qrPdfData, isValidForm: renderForm });
  }, [renderForm]);

  return (
    <div className="qr-pdf">
      <Typography
        Tag="p"
        size="xl"
      >
        {data.title}
      </Typography>
      <Form
        fields={dataPdfWithDefaultValues}
        schema={pdfValidation(data, t)}
        onWatchFields={({ field, value }) => onUpdateState({ field, value })}
        isFormValid={(isValidForm) => setRenderForm(isValidForm)}
      />
    </div>
  );
};
